import { z } from '../zod';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { OrderBumpPageTypeValidationSchema } from './enum';

export const OrderBumpPagePathParamsValidationSchema = z.object({
  pageId: ObjectIdStringValidationSchema.meta({
    description: 'The ID of the checkout page or event.',
  }),
});

export const OrderBumpPathParamsValidationSchema = OrderBumpPagePathParamsValidationSchema.extend({
  productId: ObjectIdStringValidationSchema.meta({
    description: 'The ID of the order bump product placed on the page.',
  }),
});

export const OrderBumpPageParamsValidationSchema = z.object({
  pageId: ObjectIdStringValidationSchema.meta({
    description:
      'The ID of the checkout page or event. Use the type you fetched it with (get_checkout_page or get_event).',
  }),
  pageType: OrderBumpPageTypeValidationSchema,
});

export const OrderBumpParamsValidationSchema = OrderBumpPageParamsValidationSchema.extend({
  productId: ObjectIdStringValidationSchema.meta({
    description:
      'The ID of the order bump product placed on the page. Listed as `productId` by list_order_bumps.',
  }),
});
